export default __webpack_public_path__ + "static/media/bank.8fbd08b0.svg";